module.exports = __webpack_public_path__ + "img/icon-briefcase.da2205a5.svg";